export default "__VITE_ASSET__IHraT6MF__"